import { useState } from 'preact/hooks';
import { GET, GET_COLOR_FULL_SEARCH } from '../../../services';
import { useMutation } from '@tanstack/react-query';

export const useGetColor = ({ handleSubmit }) => {
  const [data, setData] = useState([]);

  const { isPending, mutate: onSearchFull } = useMutation({
    mutationFn: async (searchParamState) => {
      const { search } = searchParamState;
      const response = await GET(
        GET_COLOR_FULL_SEARCH({
          search: search || '',
        }),
      );
      return response.result.items || [];
    },
    onSuccess: (response) => {
      setData(response);
    },
  });

  const onFetch = () =>
    handleSubmit((values) => {
      return onSearchFull(values);
    })();

  return { dataSource: data, setData, onSearchFull, loading: isPending, onFetch };
};
